import React, { useEffect, useState, useCallback } from "react";
import { Modal, Toast } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getTestimonialDetails } from "../../modules/Testimonial/testimonialSlice";
import { Cancel01Icon } from "../../assets/icons";

export default function TestimonialView({
  show,
  handleClose,
  testimonialId,
}) {
  const [testimonial, setTestimonial] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const dispatch = useDispatch();

  const fetchTestimonial = useCallback(async () => {
    try {
      const result = await dispatch(getTestimonialDetails(testimonialId));
      setTestimonial(result.payload.data);
    } catch (error) {
      setSnackbarMessage("Failed to load testimonial details!");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
    }
  }, [dispatch, testimonialId]);

  useEffect(() => {
    if (testimonialId && show) {
      fetchTestimonial();
    }
  }, [testimonialId, show, fetchTestimonial]);

  const handleModalClose = useCallback(() => {
    setTestimonial(null);
    handleClose();
  }, [handleClose]);

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Modal
        show={show}
        size="lg"
        centered
        dialogClassName="common-popup-dialog"
        contentClassName="common-popup-content"
        backdropClassName="common-popup-backdrop"
        onHide={handleModalClose}
      >
        <Modal.Body className="common-popup-body">
          <div
            className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center common-popup-close-btn"
            onClick={handleModalClose}
          >
            <Cancel01Icon width={16} height={16} color="#BCBBC1" strokeWidth="2.5" />
          </div>
          <div className="mb-4 text-center common-popup-heading">
            <h4 className="text-capitalize mb-2 fw-medium">View Testimonial</h4>
            <p>Testimonial details</p>
          </div>

          {testimonial ? (
            <div>
              <div className="mb-4">
                <strong>Name:</strong>
                <p>{testimonial.client_name}</p>
              </div>

              <hr></hr>

              <div className="mb-4">
                <strong>Address</strong>
                <p>{testimonial.client_address}</p>
              </div>

              <hr></hr>

              <div className="mb-4">
                <strong>Message</strong>
                <p>{testimonial.client_message}</p>
              </div>

              <hr></hr>

              {/* Display Image */}
              {testimonial.client_image && (
                <div className="mb-4">
                  <strong>Testimonial Image:</strong>
                  <div>
                    <img src={testimonial.client_image} alt="Testimonial" className="img-fluid" height={"100px"} width={"100px"} />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <p>Loading testimonial details...</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
